<template>
  <div>
    <div class="px-[1.429rem] lg:max-w-4/5 lg:px-0 mt-[1.5rem] lg:mt-0">
      <div class="pt-[2.143rem] mb-6">
        <Heading :level="2" color="text-ash-200"> {{ question }} </Heading>
      </div>
      <div class="text-ash-100 font-normal faq-answer" v-html="answer"></div>
    </div>
    <div class="px-[1.429rem] mb-24 lg:mb-[21.0714285714rem] lg:px-0">
      <div class="pt-[3.714rem] mb-6 pb-[1.357rem] border-b border-gray-300">
        <Heading :level="3" color="text-ash-200"> 
          <Icon icon="question" class="text-pink mr-[0.429rem] text-[2.143rem]" aria-hidden="true"/> 
          {{ helpfulText }}
        </Heading>
      </div>
      <div class="flex">
        <div v-if="!voted">
          <Button :class="`${voteButtonClass} mr-[1.2857rem]`" aria-label="Mark article as helpful" title="Mark article as helpful" type="button" id="faq-ques-ans-yes" variant="primary" theme="LIGHT" size="sm" @click="handleVoteUpdate('yes')">Yes</Button>
          <Button :class="voteButtonClass" aria-label="Mark article as not helpful" title="Mark article as not helpful" type="button" id="faq-ques-ans-no" variant="primary" theme="LIGHT" size="sm" @click="handleVoteUpdate('no')">No</Button>
        </div>
        <p v-else class="text-[1rem] font-normal text-ash-100">Thank you!</p>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
  import {ref} from "vue"
  import Button from "../../atom/button.vue"
  import Heading from "../../atom/heading.vue"
  import Icon from '../../atom/icon.vue'

  const props = defineProps<{
    question?: string
    answer?: string
    helpfulText: string
  }>()

  const voteButtonClass = 'button is-large min-w-[7.5714285714rem] border px-[1rem] border-gray-900 font-medium cursor-pointer';

  const emit = defineEmits<{
    (e: "vote", value: "yes" | "no"): void;
  }>();

  const voted = ref(false);
  const handleVoteUpdate = (vote: "yes" | "no") => {
    voted.value = true;
    emit("vote", vote);
  };
</script>
